import React, { useState } from "react";
import { de, enGB } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { formatDate } from "@/lib/dateFormat";
import { useI18n } from "@/context/I18nContext";

const pad2 = (n) => String(n).padStart(2, "0");
const toIso = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
const fromIso = (s) => {
  const [y, m, d] = (s || "").split("-").map(Number);
  return y && m && d ? new Date(y, m - 1, d) : undefined;
};

export const DatePicker = ({ value, onChange, testId }) => {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  const selected = fromIso(value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="w-full justify-start font-mono-jb font-normal text-foreground hover:bg-muted/60 hover:text-foreground data-[state=open]:border-primary data-[state=open]:bg-background data-[state=open]:text-foreground" data-testid={testId}>
          <CalendarDays className="mr-2 h-4 w-4 text-primary" />
          {selected ? formatDate(selected) : <span className="text-muted-foreground">{t("pick_date")}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testId}-popover`}>
        <Calendar
          mode="single"
          locale={lang === "en" ? enGB : de}
          weekStartsOn={1}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => {
            if (d) {
              onChange(toIso(d));
              setOpen(false);
            }
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
